<template>
  <div>
    <el-carousel v-if="screenWidth > 768" height="900px" :width="width" direction="vertical" :autoplay="true">
      <el-carousel-item v-for="item in 1" :key="item">
        <CarouselItem @openLogin="emitLogin" />
      </el-carousel-item>
    </el-carousel>
    <div class="page_home flex-col" v-else :width="screenWidth">
      <img src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/img/index/bg-bottom.png"
        style="width: 100%;" />
      <div class="group_3_home flex-col">
        <span class="text_2_home">软件行业营销套餐</span>
        <div class="text-wrapper_1_home flex-row justify-between">
          <span class="text_3_home">限时火爆</span>
          <span class="text_4_home">售卖中</span>
        </div>
        <div class="box_2_home flex-col"></div>
        <span
          class="paragraph_1_home">商用软件、企业服务、B2B平台全行业适用<br />工商查询+AI拓客&nbsp;&nbsp;人群包DIY+大模型生成&nbsp;&nbsp;多元营销通道、精准触达</span>
        <div class="text-wrapper_3_home flex-col" @click="handleOpen">
          <span class="text_11_home">立即领取限额优惠</span>
        </div>
      </div>
    </div>
    <LoginPublic :dialogVisible="dialogVisible" @handleClose="handleClose" />
  </div>
</template>

<script>
import navigeation from '../components/navigation.vue';
import CarouselItem from './carousel-item.vue';
import LoginPublic from '../components/login-public.vue'

export default {
  components: {
    navigeation,
    CarouselItem,
    LoginPublic,
  },
  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight - 60,
      //需查询的公司名称
      corporateName: '',
      logo: 'https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/logo.png',
      selectPanel: 'home',

      //历史记录
      historyList: [],
      screenWidth: 0,
      dialogVisible: false,
    }
  },

  mounted() {
    this.historyList = JSON.parse(localStorage.getItem('History'));

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },

  methods: {
    //免费注册
    handleOpen() {
      this.dialogVisible = true;
    },

    handleClose() {
      this.dialogVisible = false;
    },
    changePanel(panel) {
      this.selectPanel = panel
    },
    emitLogin() {
      this.$emit("openLogin");
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

}
</script>
<!-- <style scoped lang="css" src="@/assets/index/home.css" /> -->
<style scoped lang="css">
.page_home {
  position: relative;
  width: 100%;
  /* height: 214.38vw; */
  overflow: hidden;
}

.group_3_home {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  /* height: 87.09vw; */
  padding: 20.75vw 2.29vw 0 6.66vw;
}

.text_2_home {
  background-image: linear-gradient(127deg,
      rgba(0, 207, 255, 1) 0,
      rgba(20, 113, 234, 1) 100%);
  overflow-wrap: break-word;
  color: rgba(22, 119, 255, 1);
  font-size: 8.75vw;
  letter-spacing: 3.8888888359069824px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 12.09vw;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 19.29vw 15.41vw 0 0.2vw;
}

.text-wrapper_1_home {
  width: 62.71vw;
  margin: 1.87vw 28.33vw 0 0;
}

.text_3_home {
  overflow-wrap: break-word;
  color: rgba(242, 113, 66, 1);
  font-size: 7.91vw;
  letter-spacing: 3.5185184478759766px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 10.84vw;
  margin-top: 0.42vw;
}

.text_4_home {
  background-image: linear-gradient(127deg,
      rgba(0, 207, 255, 1) 0,
      rgba(20, 113, 234, 1) 100%);
  overflow-wrap: break-word;
  color: rgba(22, 119, 255, 1);
  font-size: 8.75vw;
  letter-spacing: 3.8888888359069824px;
  font-family: AlibabaPuHuiTiM;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12.09vw;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.box_2_home {
  background-color: rgba(22, 119, 255, 1);
  border-radius: 7px;
  width: 10.84vw;
  height: 0.84vw;
  margin: 3.12vw 80.2vw 0 0;
}

.paragraph_1_home {
  width: 91.05vw;
  height: 20vw;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 4.16vw;
  font-weight: normal;
  text-align: left;
  line-height: 6.46vw;
  margin-top: 4.8vw;
}

.text-wrapper_3_home {
  height: 7vw;
  background-image: linear-gradient(to right, #00CFFF, #156EE9);
  border-radius: 25px;
  background-size: 100% 100%;
  width: 37.25vw;
  cursor: pointer;
  margin-top: 40px;
}

.text_11_home {
  width: 100%;
  height: 100%;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 3.54vw;
  letter-spacing: 0.699999988079071px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 7vw;
  /* margin: 0.41vw 0 0 1.11vw; */
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue